import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import '@fontsource/inter';

// "ResizeObserver loop completed with undelivered notifications" is a harmless browser notice (antd popups,
// tooltips and tables trigger it). The dev error overlay (webpack-dev-server) shows it as a crash, and its own
// listener runs before ours, so the overlay is removed right after it appears. Real errors are untouched.
const RESIZE_OBSERVER_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];
const removeDevOverlay = (): void => {
  document.getElementById('webpack-dev-server-client-overlay')?.remove();
  document.getElementById('webpack-dev-server-client-overlay-div')?.remove();
};
window.addEventListener(
  'error',
  (event) => {
    if (RESIZE_OBSERVER_MESSAGES.includes(event.message)) {
      event.stopImmediatePropagation();
      // the overlay is created asynchronously, so remove it a few times
      [0, 50, 150, 400].forEach((delay) => {
        window.setTimeout(removeDevOverlay, delay);
      });
    }
  },
  true
);

const root = ReactDOM.createRoot(
  // eslint-disable-next-line @typescript-eslint/non-nullable-type-assertion-style
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
